export default "__VITE_ASSET__7vQPNpD2__"